import type { ActionDefinition, ActionSectionId } from 'state/actionDefinitions'

const TOP_TIER_COMMAND_TAG_GROUPS_BY_SECTION: Partial<Record<ActionSectionId, string[][]>> = {
    image: [['illustrate'], ['nb'], ['nbpro'], ['gptimage2.5'], ['flux2'], ['grokimage']],
    video: [
        ['film'],
        ['seedance2.5', 'seedance'],
        ['h3max'],
        ['kling', 'kling4'],
        ['grokvideo1.5'],
        ['grokvideo'],
        ['extend'],
    ],
    audio: [['minimaxmusic'], ['suno'], ['elevenmusic'], ['stableaudio']],
    tools: [['gif'], ['screenshot'], ['stitch']],
}

const MORE_FIRST_COMMAND_TAGS_BY_SECTION: Partial<Record<ActionSectionId, string[]>> = {
    image: ['gptimage2.5sunburst'],
}

const HIDDEN_COMMAND_TAGS_BY_SECTION: Partial<Record<ActionSectionId, Set<string>>> = {
    image: new Set(['gptimage2']),
}

export function partitionActionDefinitionsByFold(
    sectionId: ActionSectionId,
    items: ActionDefinition[],
): { topTier: ActionDefinition[]; more: ActionDefinition[] } | null {
    const topTierCommandTagGroups = TOP_TIER_COMMAND_TAG_GROUPS_BY_SECTION[sectionId]
    if (!topTierCommandTagGroups) return null
    const hiddenCommandTags = HIDDEN_COMMAND_TAGS_BY_SECTION[sectionId] || new Set<string>()
    const visibleItems = items.filter(model => !hiddenCommandTags.has(model.actionTagName))

    const topTier = topTierCommandTagGroups
        .map(commandTagGroup =>
            commandTagGroup
                .map(commandTag => visibleItems.find(model => model.actionTagName === commandTag))
                .find(Boolean),
        )
        .filter(Boolean) as ActionDefinition[]
    const topTierCommandTags = topTierCommandTagGroups.flat()
    const remaining = visibleItems.filter(
        model => !topTierCommandTags.includes(model.actionTagName),
    )
    const moreFirstCommandTags = MORE_FIRST_COMMAND_TAGS_BY_SECTION[sectionId] || []
    const pinnedMore = moreFirstCommandTags
        .map(commandTag => remaining.find(model => model.actionTagName === commandTag))
        .filter(Boolean) as ActionDefinition[]
    const pinnedMoreCommandTags = new Set(pinnedMore.map(model => model.actionTagName))

    return {
        topTier,
        more: [
            ...pinnedMore,
            ...remaining.filter(model => !pinnedMoreCommandTags.has(model.actionTagName)),
        ],
    }
}
